import { render, staticRenderFns } from "./FreeTierSuccess.vue?vue&type=template&id=ab14bed4"
import script from "./FreeTierSuccess.vue?vue&type=script&lang=js"
export * from "./FreeTierSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports